// pages/Channels/Channels.js
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box, Typography, Grid, Card, CardContent, CardActions,
  Button, Avatar
} from "@mui/material";
import {
  WhatsApp as WhatsAppIcon,
  Sms as SmsIcon,
  ArrowForward as ArrowForwardIcon
} from "@mui/icons-material";

export default function Channels() {
  const navigate = useNavigate();
  const { chatbotId } = useParams();

  useEffect(() => {
    document.title = "Channels | KlonIT Web Application";
  }, []);

  const cards = [
    {
      title: "WhatsApp Bot",
      description:
        "Automate conversations with intelligent chat responses, handling customer queries efficiently.",
      icon: <WhatsAppIcon sx={{ fontSize: 60, color: "#25D366" }} />,
      link: `/chatbot/${chatbotId}/channels/whatsapp`,
      color: "#25D366",
    },
    {
      title: "SMS Bot",
      description:
        "Automate conversations with intelligent chat responses, handling customer queries efficiently.",
      icon: <SmsIcon sx={{ fontSize: 60, color: "#1976d2" }} />,
      link: `/chatbot/${chatbotId}/channels/sms`,
      color: "#1976d2",
    },
  ];

  return (
    <Box sx={{ p: 3, mt: 10 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700}>
          Channels
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure messaging channels for your chatbot
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-4px)",
                },
              }}
              onClick={() => navigate(card.link)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center", pt: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: `${card.color}15`,
                    margin: "0 auto 16px",
                  }}
                >
                  {card.icon}
                </Avatar>
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center", pb: 3 }}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ bgcolor: card.color }}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
